var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"text-center mt-8"},[_vm._v(" "+_vm._s(_vm.$t('area_required'))+" [ "),_c('a',{attrs:{"href":_vm.officialLineUrl,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.$t('here')))]),_vm._v(" ] ")])}
var staticRenderFns = []

export { render, staticRenderFns }